module.exports = __webpack_public_path__ + "img/cantante-lirica-cerimonia.5845104b.jpg";